<script>
	import { makepuzzle, ratepuzzle, solvepuzzle } from "sudoku";
	import { range } from "./util";
	import Cell from "./Cell.svelte";
	import { onMount } from "svelte";

	function lsGet(k, def) {
		if(typeof localStorage === "undefined")
			return def;

		const val = localStorage.getItem(k);
		if(!val)
			return def;

		return JSON.parse(val);
	}

	function lsSet(k, val) {
		if (typeof localStorage !== "undefined")
			localStorage.setItem(k, JSON.stringify(val));
	}

	// const range3 = range(3);
	const range9 = range(9);
	const range81 = range(81);
	const boxIndexes = [0, 1, 2, 9, 10, 11, 18, 19, 20];
	const history = [];

	let dark_mode = false;
	let cell;
	let rate;
	let solution;
	let orig;
	let pens;
	let start;
	let time = "00:00:00";

	setInterval(
		() =>
			(time = new Date(new Date().getTime() - start)
				.toISOString()
				.substring(11, 19)),
		1000
	);

	cell = lsGet('cell');
	pens = lsGet('pens');
	rate = lsGet('rate');
	solution = lsGet('solution');
	orig = lsGet('orig');
	start = lsGet('start');

	if(!cell){
		reset();
	}
	
	let sel_num = null;
	let sel_i = null;
	let pen_mode = false;
	let counts = null;

	$: counts = makeCounts(cell);

	function makeCounts(cell) {
		const counts = range9.map(() => 0);
		cell.forEach((v) => v !== null && counts[v]++);
		return counts;
	}

	function clearPens(i, n) {
		const colStart = i % 9;
		const rowStart = i - colStart;
		const boxStart = i - (i % 3) - (Math.floor(i / 9) % 3) * 9;

		[
			...range(rowStart, rowStart + 9), // row
			...range(colStart, colStart + 81, 9), // col
			...boxIndexes.map((i) => boxStart + i), // box
		].forEach((i) => (pens[i][n] = false));

		pens = pens;
		lsSet('pens', pens);
	}

	function pushHistory() {
		history.push(JSON.stringify({ cell, pens }));
	}

	function popHistory() {
		if (!history.length) return;
		({ cell, pens } = JSON.parse(history.pop()));
		lsSet('cell', cell);
		lsSet('pens', pens);
	}

	function c(i) {
		sel_i = i;
		if (!pen_mode) {
			if (!orig[i] && (cell[i] === null || sel_num === null)) {
				pushHistory();
				cell[i] = sel_num;
				cell = cell;
				lsSet('cell', cell);
				clearPens(i, sel_num);
			}
		} else if (sel_num !== null) {
			pushHistory();
			pens[sel_i][sel_num] = !pens[sel_i][sel_num];
			pens = pens;
			lsSet('pens', pens);
		}
	}

	function reset() {
		while(history.length) history.pop();

		do {
			cell = makepuzzle();
		} while ((rate = ratepuzzle(cell, 4)) > 2);

		solution = solvepuzzle(cell);
		orig = cell.map((n) => n !== null);
		pens = range81.map((_) => range9.map(() => false));
		start = new Date().getTime();

		lsSet('cell', cell);
		lsSet('pens', pens);
		lsSet('rate', rate);
		lsSet('solution', solution);
		lsSet('orig', orig);
		lsSet('start', start);
	}

	// export let name;
</script>

<main class:dark={dark_mode} class:clear={!dark_mode}>
	<svg viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg">

		{#each range9 as i (i)}
			<rect class="box" x={(i % 3) * 3} y={Math.floor(i / 3) * 3} />
		{/each}

		{#each range81 as i (i)}
			<Cell
				x={i % 9}
				y={Math.floor(i / 9)}
				val={cell[i]}
				selected={sel_num}
				pens={pens[i]}
				orig={orig[i]}
				solution={solution[i]}
				on:click={() => c(i)}
			/>
		{/each}

		<g transform="translate(6, 9.3)">
			<g transform="translate(-1, 0)" class:high={pen_mode}>
				<rect class="button" on:click={() => (pen_mode = !pen_mode)} />
				<text>✎</text>
			</g>

			<g transform="translate(-1, 1)">
				<rect class="button" on:click={popHistory} />
				<text>⤺</text>
			</g>

			{#each range9 as i (i)}
				<g
					transform="translate({i % 3}, {Math.floor(i / 3)})"
					class:high={i === sel_num}
					class:complete={counts[i] === 9}
				>
					<rect class="button" on:click={() => (sel_num = i)} />
					<text>{i + 1}</text>
					<text class="count">{counts[i]}</text>
				</g>
			{/each}

			<g transform="translate(-1, 2)" class:high={null === sel_num}>
				<rect class="button" on:click={() => (sel_num = null)} />
				<text>⍉</text>
			</g>
		</g>

		<g transform="translate(0, 11.3)">
			<rect class="button" on:click={() => (dark_mode = !dark_mode)} />
			<text>☼</text>
		</g>

		<g transform="translate(1, 11.3)">
			<rect class="button" on:click={reset} />
			<text>↻</text>
		</g>
	</svg>
	Dificultad {rate} &mdash; {time}
</main>

<style>
	main {
		min-height: 100vh;
	}
	svg {
		margin: 10px 0;
		width: 100vw;
		height: calc(100vw * 1.3);
		fill: none;
	}
	.box {
		width: 3px;
		height: 3px;
		stroke-width: 0.05px;
	}
	.row {
		width: 9px;
		height: 1px;
	}
	.col {
		width: 1px;
		height: 9px;
	}
	.button {
		stroke-width: 0.05px;
		width: 1px;
		height: 1px;
		rx: 0.2px;
		ry: 0.2px;
		fill: rgba(0, 0, 0, 0);
		stroke: rgba(0, 0, 0, 0);
	}
	text {
		font-size: 0.7px;
		transform: translate(0.5px, 0.75px);
		pointer-events: none;
		text-anchor: middle;
	}
	text.count {
		font-size: 0.3px;
		transform: translate(0.85px, 0.9px);
	}
</style>
